import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Container, InputGroup, Input, Button, Table } from 'reactstrap';
import Yang from './Yang';
import axios from 'axios';
import YangsicDetail from './YangsicDetail';
import stylesCoup from '../Shared/Css/VideosMy/VideosMyList.module.css';

// const defaultEmpVideoSrc = '/empImg/video_placeholder.png'
const defaultEmpVideoExcelSrc = '/empImg/excel_placeholder.png';
const defaultEmpVideoPdflSrc = '/empImg/pdf_placeholder.png';
const defaultEmpVideoTxtlSrc = '/empImg/text_placeholder.png';
const defaultEmpVideo7zSrc = '/empImg/7z.png';
const defaultEmpVideohancomSrc = '/empImg/hancom.png';

function YangList() {
  const [yangsicList, setYangsicList] = useState([]);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [progress, setProgress] = useState({ started: false, pc: 0 });
  const [msg, setMsg] = useState(null);
  const [randring, setRandring] = useState(false);
  const [yangsicValue, setYangsicValue] = useState(null);
  const [yangsicDetailTrue, setYangsicDetailTrue] = useState(false);
  const [yangsicNameChange, setYangsicNameChange] = useState('');

  //히스토리사용
  const history = useHistory();

  useEffect(() => {
    if (randring === false) {
      setRandring(true);
      refreshYangsicList();
    }
    //경고문 해제
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const proGressResult = useMemo(() => {
    return {
      onUploadProgress: (progressEvent)  => {
        setProgress((prevState) => {
          return{ ...prevState, pc: progressEvent.progress * 100 };
        });
      },
    };
  }, []);

  const headers = useCallback(() => {
    return {
      'Content-type': `text/plain`,
      // headers: { "Content-Type": `multipart/form-data` }
    };
  }, []);

  const yangsicAPI = useCallback(() => {
    const url = '/api/Yangsic/';
    const urlFileDown = '/api/YangsicFileDown/';

    return {
      fetchAll: () =>  axios.get(url, { params: { yangsicName: yangsicNameChange } }),
      // fetchAll: () => axios.get(url),
      create: (newRecord) =>
        axios.post(url, newRecord, proGressResult, { headers }).then((res) => {   
          setProgress({started: false, pc: 0 })
          // setMsg('정상적으로 저장되었습니다.');
          // console.log(res.data);
        }),
      update: (id, updatedRecord) => axios.put(url + id, updatedRecord).then((res) => {
        setProgress({ started: false, pc: 0 })
      }),
      delete: (id) => axios.delete(url + id),
      download: (id) => axios.get(urlFileDown + id, { headers }),
    };
  }, [yangsicNameChange, headers, proGressResult]);

  const refreshYangsicList = useCallback(async () => {
    await yangsicAPI()
      .fetchAll()
      .then((res) => {
        setYangsicList(res.data);
      })
      .catch((err) => {
        // console.log(err)   
      });
  }, [yangsicAPI]);

  const addOrEdit = useCallback(
    async (formData, onSuccess) => {
      if (formData.get('yangsicId') === '0')
        await yangsicAPI()
          .create(formData)
          .then((res) => {
            onSuccess();
            refreshYangsicList();
          })
          .catch((err) => {
            alert("용량초과 했는지 검토하세요")
            // console.log(err);
          });
      else
        await yangsicAPI()
          .update(formData.get('yangsicId'), formData)
          .then((res) => {
            onSuccess();
            refreshYangsicList();
          })
          .catch((err) => {
            // console.log(err);
          });
    },
    [yangsicAPI, refreshYangsicList]
  );

  const showRecordDetails = (data) => {
    // console.log(data)
    setRecordForEdit(data);
  };

  const onDelete = useCallback(
    (e, id) => {
      e.stopPropagation();
      if (window.confirm('이 레코드를 삭제하시겠습니까?'))
        yangsicAPI()
          .delete(id)
          .then((res) => refreshYangsicList())
          .catch((err) => {
            // console.log(err)       
          });
    },
    [yangsicAPI, refreshYangsicList]
  );

  const onDownload = useCallback(
    (e, id) => {
      e.preventDefault();
      if (window.confirm('다운로드를 하겠습니까?'))
        yangsicAPI()
          .download(id)
          .then((res) => {
            const url = res.config.url;
            window.location.href = url; //다운로드 Url
          })
          .catch((err) => { 
            // console.log(err)
          }
          );
    },
    [yangsicAPI]
  );

  const yangsicHandle = (e) => {
    setYangsicValue(e.target.src);
    setYangsicDetailTrue(true);
  };

  const handleInputEmpNameChange = (e) => {
    e.preventDefault();
    setYangsicNameChange(e.target.value);
  };

  const handleInputEmpNameEnter = (e) => {
    e.preventDefault();
    if (e.key === 'Enter') {
      refreshYangsicList(); // Enter 입력이 되면 클릭 이벤트 실행
    }
  };
  const handleInputEmpNameChangeQuary = (e) => {
    e.preventDefault();
    refreshYangsicList(); // Enter 입력이 되면 클릭 이벤트 실행
  };

  const yangsicImageCard = useCallback(
    (data) => (
      <div className={`card ${stylesCoup.cardd}`}
        onClick={() => {
          showRecordDetails(data);
        }}
      >
        {data.yangsicImageType === 'image/png' ? (<img src={data.yangsicImageSrc} className="card-img-top rounded-rounded" alt="" />)
          : data.yangsicImageType === 'image/bmp' ? (<img src={data.yangsicImageSrc} className="card-img-top rounded" alt="" />)
            : data.yangsicImageType === 'image/jpeg' ? (<img src={data.yangsicImageSrc} className="card-img-top rounded" alt="" />)
              : data.yangsicImageType === 'image/gif' ? (<img src={data.yangsicImageSrc} className="card-img-top rounded" alt="" />)
                : data.yangsicImageType === 'video/mp4' ? (<video src={data.yangsicImageSrc} controlsList="nodownload" className="card-img-top rounded" onClick={yangsicHandle}></video>)
                  : data.yangsicImageType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? (<img src={defaultEmpVideoExcelSrc} className="card-img-top rounded" alt="" ></img>)
                    : data.yangsicImageType === 'application/pdf' ? (<img src={defaultEmpVideoPdflSrc} className="card-img-top rounded" alt="" ></img>)
                      : data.yangsicImageType === 'text/plain' ? (<img src={defaultEmpVideoTxtlSrc} className="card-img-top rounded" alt="" ></img>)
                        : data.yangsicImageType === 'application/x-zip-compressed' ? (<img src={defaultEmpVideo7zSrc} className="card-img-top rounded" alt="" ></img>)
                          : data.yangsicImageType === 'application/haansofthwp' ? (<img src={defaultEmpVideohancomSrc} className="card-img-top rounded" alt="" ></img>)
                        : (<img src={data.yangsicImageSrc} className="card-img-top rounded" alt="" />
                        )}
        <div className={`card-body ${stylesCoup.cardBody}`}>
          <Table bordered size="sm" className={stylesCoup.empTableCard} >
            <thead>
              <tr>
                <th>파일명</th>
                <th>작성자</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{data.yangsicName}</td>
                <td>{data.yangsicRegName}</td>
              </tr>
            </tbody>
            <thead>
              <tr>
                <th colSpan={2}>파일설명[기타]</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={2}>{data.yangsicDesc}</td>
              </tr>
            </tbody>
          </Table>
          <button className={`btn btn-white ${stylesCoup.deleteButton}`} onClick={(e) => onDelete(e, parseInt(data.yangsicId))} >
            <i className="far fa-trash-alt" style={{ fontSize: '26px', color: 'red' }}></i>
          </button>
          <button
            className={`btn btn-white ${stylesCoup.deleteButton}`}
            onClick={(e) => onDownload(e, parseInt(data.yangsicId))}
          >
            <i className="fa-regular fa-floppy-disk"
              style={{ fontSize: '26px', color: 'blue' }}
            ></i>
          </button>
          {/* {
          data.yangsicImageType === "application/pdf" ? <button className="btn btn-white delete-button" onClick={e => onDownload(e, parseInt(data.empId))}>
            <i className="fa-regular fa-floppy-disk" style={{ fontSize: '26px', color: "blue" }}></i>
          </button>
            : data.yangsicImageType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? <button className="btn btn-white delete-button" onClick={e => onDownload(e, parseInt(data.empId))}>
              <i className="fa-regular fa-floppy-disk" style={{ fontSize: '26px', color: "blue" }}></i>
            </button>
              : ""
        } */}
        </div>
      </div>
    ),
    [onDelete, onDownload]
  );

  return (
    <Container fluid="sm" className={stylesCoup.empContainer}>
      <div className="row">
        <div className={`col-md-12 ${stylesCoup.empDamun}`}>
          <Button className={stylesCoup.btn} color="warning"
            onClick={() => { history.goBack(); }}  //이게 더빠름
          // onClick={() => { history.push('/'); }}
          // onClick={() => {
          //   window.location.href = '/home/index';
          // }}
          >
            나가기
          </Button>
          <div
            className={`container-fluid p-5 mt-1 bg-info text-white ${stylesCoup.empHidden}`}
            style={{ textAlign: 'center' }}
          >
            <h1>양식파일등록</h1>
            <p className="lead">
              최대200MB까지 등록할수 있습니다[동영상,엑셀,파워포인트,Pdf 등등...]
            </p>
          </div>
        </div>
        <div className="col-md-3">
          <Yang
            addOrEdit={addOrEdit}
            recordForEdit={recordForEdit}
            setRecordForEdit={setRecordForEdit}
            setProgress={setProgress}
            progress={progress}
            setMsg={setMsg}
            msg={msg}
          />
        </div>
        <div className="col-md-9">
          <div className={`row ${stylesCoup.empList}`}>
            <div className={`col-8 ${stylesCoup.empLi00}`}>양식파일리스트</div>
            <div className={`col-4 ${stylesCoup.empLi01}`}>
              <InputGroup size="sm">
                <Input
                  className={stylesCoup.empPl}
                  placeholder="검색"
                  name="empNameChange"
                  value={yangsicNameChange}
                  onChange={handleInputEmpNameChange}
                  onKeyUp={handleInputEmpNameEnter}
                  onClick={() => {
                    setYangsicNameChange('');
                  }}
                />
                <Button
                  size="sm"
                  color="success"
                  onClick={handleInputEmpNameChangeQuary}
                >
                  <i className="fa-solid fa-magnifying-glass" />
                </Button>
              </InputGroup>
            </div>
          </div>
          {Math.ceil(yangsicList.length) !== 0 ? (
            <table>
              <tbody className={stylesCoup.empTbody}>
                {[...Array(Math.ceil(yangsicList.length / 3))].map((e, i) => {
                  return (
                    <tr key={i}>
                      <td>{yangsicImageCard(yangsicList[3 * i])}</td>
                      <td>
                        {yangsicList[3 * i + 1]
                          ? yangsicImageCard(yangsicList[3 * i + 1])
                          : null}
                      </td>
                      <td>
                        {yangsicList[3 * i + 2]
                          ? yangsicImageCard(yangsicList[3 * i + 2])
                          : null}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className={stylesCoup.empContainermessage01}>
              <div className={stylesCoup.empContainermessage02}>
                <p >검색된 자료가 없습니다.</p>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* 비디오재생모달 */}
      {yangsicDetailTrue === true ? (
        <YangsicDetail
          yangsicDetailTrue={yangsicDetailTrue}
          setYangsicDetailTrue={setYangsicDetailTrue}
          yangsicValue={yangsicValue}
        />
      ) : null}
    </Container>
  );
}

export default YangList;
